// extracted by mini-css-extract-plugin
module.exports = {"App":"styles_App__1QDQB","table":"styles_table__1Ac1q","tabs":"styles_tabs__3Sxl1","codes":"styles_codes__3GVt9","total":"styles_total__XRFeh"};